// extracted by mini-css-extract-plugin
export default {"wrapper":"skill_title_button-module___wrapper___dcb08aee"};